<template>
  <on-click-outside :do="close">
    <div>
      <div class="input-group date">
        <input
          type="text"
          class="form-control"
          :value="value"
          @input="onInputTime"
          v-bind="{
            placeholder: format,
            ...$attrs
          }"
          ref="inputDatePicker"
          @focus="open"
        />
        <div class="input-group-addon" @click="open">
          <i class="fa fa-clock"></i>
        </div>
      </div>
      <div
        class="bootstrap-datetimepicker-widget dropdown-menu bottom date-picker-dropdown"
        ref="dropdown"
        v-show="isOpen"
      >
        <time-picker @change="selectTime" :use24Hour="use24Hour" />
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import Popper from 'popper.js'
import OnClickOutside from '@/components/OnClickOutside'
import TimePicker from '@/components/TimePicker'

export default {
  name: 'TsTimePickerInput',
  inheritAttrs: false,
  components: { OnClickOutside, TimePicker },
  props: {
    value: {
      type: String
    },
    closeOnSelect: {
      type: Boolean
    },
    use24Hour: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    format() {
      return this.use24Hour ? 'HH:mm' : 'hh:mm a'
    }
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  methods: {
    open() {
      if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) {
        return
      }

      if (this.isOpen) {
        return
      }

      this.isOpen = true
      this.$nextTick(() => {
        this.setupPopper()
      })
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.inputDatePicker, this.$refs.dropdown, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            offset: {
              enabled: true,
              fn: data => {
                data.offsets.popper.left = data.offsets.reference.left
                data.offsets.popper.right = data.offsets.reference.right

                return data
              },
              order: 840
            }
          }
        })
      } else {
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
    },
    selectTime(time) {
      this.$emit('input', time)

      if (this.closeOnSelect) this.close()
    },
    onInputTime(e) {
      // // ^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$
      // // ^(?=\d{2}([-.,\/])\d{2}\1\d{4}$)(?:0[1-9]|1\d|[2][0-8]|29(?!.02.(?!(?!(?:[02468][1-35-79]|[13579][0-13-57-9])00)\d{2}(?:[02468][048]|[13579][26])))|30(?!.02)|31(?=.(?:0[13578]|10|12))).(?:0[1-9]|1[012]).\d{4}$

      // let dateRegex = /^(?=\d{2}([-.,\/])\d{2}\1\d{4}$)(?:0[1-9]|1\d|[2][0-8]|29(?!.02.(?!(?!(?:[02468][1-35-79]|[13579][0-13-57-9])00)\d{2}(?:[02468][048]|[13579][26])))|30(?!.02)|31(?=.(?:0[13578]|10|12))).(?:0[1-9]|1[012]).\d{4}$/

      // if (!dateRegex.test(e.target.value)) return

      this.$emit('input', e.target.value)
    }
  }
}
</script>
